/** @jsxImportSource react */
import Script from 'next/script';

import './onetagWindow';

import { ONETAG_SCRIPT_SRC } from './constants';

/**
 * 모비온 원태그 컨테이너(tcs.js) 로더.
 * 컨테이너가 콘솔에 발행된 스크립트(데이터매니저)를 자동 주입하고, 데이터매니저가
 * 콘솔 발행 설정(경로 트리거 + ENP_VAR 변수 수집)에 따라 방문·본상품 수집을 전송한다.
 * 본상품 필드는 상세 페이지에서 onetagCollect가 ENP_VAR 세팅 후 callDM()으로
 * 수집을 트리거한다 — SPA 상품 간 이동 시에도 재수집된다(모비온 SPA 가이드).
 */
export function Onetag() {
  return <Script id="enliple-onetag" src={ONETAG_SCRIPT_SRC} strategy="afterInteractive" />;
}
